import { useTranslation } from "react-i18next";

import { SectionDivider } from "src/core/components/custom-ui/section-divider";
import { Spinner } from "src/core/components/custom-ui/spinner";
import { InformationsPMSection } from "src/core/components/folder/entities/preview/InformationsPMSection";
import { InformationsPPHSection } from "src/core/components/folder/entities/preview/InformationsPPHSection";
import { NotesSection } from "src/core/components/folder/entities/preview/NotesSection";
import { PhotosSection } from "src/core/components/folder/entities/preview/PhotosSection";
import { RelationsSection } from "src/core/components/folder/entities/preview/RelationsSection";
import { RolesSection } from "src/core/components/folder/entities/preview/RolesSection";
import { SourcesSection } from "src/core/components/folder/entities/preview/SourcesSection";
import { WatchlistSection } from "src/core/components/folder/entities/preview/WatchlistSection";
import { EReputationMatchResult } from "src/core/types/entity";

type EntityDetailPreviewProps = {
  selectedMatch: EReputationMatchResult | null;
  isPPH: boolean;
};

export const EntityDetailPreview = ({ selectedMatch, isPPH }: EntityDetailPreviewProps) => {
  const { t } = useTranslation();

  return (
    <>
      {!selectedMatch && <Spinner />}
      {selectedMatch && (
        <>
          <div className="bg-white rounded-lg h-full overflow-y-auto">
            <SectionDivider>{t("modal.entityDetails.sections.informations.title")}</SectionDivider>
            {isPPH ? (
              <InformationsPPHSection selectedMatch={selectedMatch} />
            ) : (
              <InformationsPMSection selectedMatch={selectedMatch} />
            )}

            {isPPH && (
              <>
                <SectionDivider>{t("modal.entityDetails.sections.photos.title")}</SectionDivider>
                <PhotosSection selectedMatch={selectedMatch} />

                <SectionDivider>{t("modal.entityDetails.sections.roles.title")}</SectionDivider>
                <RolesSection selectedMatch={selectedMatch} />
              </>
            )}
            <SectionDivider>{t("modal.entityDetails.sections.watchlist.title")}</SectionDivider>
            <WatchlistSection selectedMatch={selectedMatch} />

            <SectionDivider>{t("modal.entityDetails.sections.sources.title")}</SectionDivider>
            <SourcesSection selectedMatch={selectedMatch} />

            <SectionDivider>{t("modal.entityDetails.sections.notes.title")}</SectionDivider>
            <NotesSection selectedMatch={selectedMatch} />

            <SectionDivider>{t("modal.entityDetails.sections.relations.title")}</SectionDivider>
            <RelationsSection selectedMatch={selectedMatch} />
          </div>
        </>
      )}
    </>
  );
};
